import * as React from 'react';
import {useHistory} from 'react-router';
import {BaseScreen} from '../../../components/screens/BaseScreen';
import {SvgImage} from '../../../components/SvgImage/SvgImage';
import {CenteredWrapper} from '../../../components/screens/layout';
import {ResendEmail} from '../layout';
import {routes} from '../routes';
import {forgotUsername} from '../../../http/login';

export const UsernameEmailSent: React.FC = () => {
  const history = useHistory<{email: string}>();
  const {email} = history.location.state;
  return (
    <BaseScreen
      helmetTitle="Username Email Sent"
      headerTitle="Forgot Username"
      title="Email Sent!"
      instructions={
        <>
          We have sent an email to <strong>{email}</strong> with further
          instructions.
        </>
      }
      actionButtons={[
        {onClick: () => history.push(routes.login.index), children: 'Login'},
      ]}
      bottomText={<ResendEmail resend={() => forgotUsername({email})} />}
    >
      <CenteredWrapper>
        <SvgImage name="mailbox" />
      </CenteredWrapper>
    </BaseScreen>
  );
};
